<template>
  <component
    :is="itemTagComputed"
    @click="
      () => {
        applyFilter()
        $emit('click')
      }
    "
    :class="[itemClass, isActive ? itemClassActive : '']"
  >
    <component
      :is="itemChildTag || 'span'"
      :class="[itemChildClass, isActive ? itemChildClassActive : '']"
    >
      <span v-html="filterGroupItem.label" />
      <span
        v-if="filterGroupItem.showCount && !isNaN(count)"
        class="ml-1"
        :class="countClass"
        >{{ count }}</span
      >
    </component>
  </component>
</template>
<script lang="ts">
// DataListQueryFilterGroupToggleItem
import { inject, PropType } from 'vue'
import { ComposableDataListService } from '../../ComposableDataListService'
import { DataListQueryFilterGroupToggleFilterGroupItem } from './DataListQueryFilterGroupToggle.vue'

export default {
  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
    filterGroupKey: {
      type: String,
      required: true,
    },
    itemTag: {},
    itemClass: {},
    itemClassActive: {},
    itemChildTag: {},
    itemChildClass: {},
    itemChildClassActive: {},
    filterGroupItem: {
      type: Object as PropType<DataListQueryFilterGroupToggleFilterGroupItem>,
      required: true,
    },
    filterConditionKeyName: {
      type: String,
      required: true,
    },
  },
  setup() {
    return {
      ComposableDataListServiceInstance: inject<ComposableDataListService>(
        'ComposableDataListServiceInstance',
      ),
    }
  },
  data() {
    return {
      filter: null,
      count: null,
    }
  },
  computed: {
    itemTagComputed() {
      return this.itemTag || 'div'
    },
    countClass() {
      if (this.count === 0 && this.filterGroupItem.countClassWhenZero) {
        return this.filterGroupItem.countClassWhenZero
      }
      if (this.filterGroupItem.countClass) {
        return this.filterGroupItem.countClass
      }
      if (this.count === 0) {
        return 'badge rounded-pill bg-light text-dark'
      }
      return 'badge rounded-pill bg-danger'
    },
  },
  watch: {
    isActive() {
      if (this.isActive) {
        // filter を適用してしまう
        this.$nextTick(() => {
          this.applyFilter()
        })
      }
    },
    // ユーザーが最後にデータを変更した時にカウントを更新する
    '$core.$uiState.userLatestStoreMethodActionTime'() {
      this.$nextTick(() => {
        this.setCount()
      })
    },
  },
  async mounted() {
    this.filter = await this.filterFormStringDefinedFunc()
    this.setCount()
    if (this.isActive) {
      // filter を適用してしまう
      this.$nextTick(() => {
        setTimeout(() => {
          this.applyFilter()
        }, 1)
      })
    }
  },
  methods: {
    async filterFormStringDefinedFunc() {
      if (!this.filterGroupItem.__func__filter) {
        return {}
      }
      try {
        const filter = await $core.$utils.executeStringDefinedFunction({
          functionString: this.filterGroupItem.__func__filter,
          functionArgValues: { thisInstance: this },
        })
        return filter || {}
      } catch (e) {
        console.error(e)
        return {}
      }
    },
    async setCount() {
      let countFilter = this.filter
      if (this.filterGroupItem.useCountCondition && this.filterGroupItem.__func__count) {
        try {
          countFilter = await $core.$utils.executeStringDefinedFunction({
            functionString: this.filterGroupItem.__func__count,
            functionArgValues: { thisInstance: this },
          })
        } catch (e) {
          console.error(e)
          countFilter = {}
        }
      }
      if (countFilter) {
        // TODO: ここで 現在 設定している tab の filter group を 除いた Filtering を 利用しなければならない
        this.count = await this.ComposableDataListServiceInstance.model.countBy(
          this.ComposableDataListServiceInstance.query.mergeFilter(countFilter, {
            excludeFilterKeys: [this.filterGroupKey],
          }),
        )
      }
    },
    applyFilter() {
      if (this.filter) {
        this.ComposableDataListServiceInstance.query.applyFilter(
          this.filterGroupKey,
          this.filter,
        )
      }
    },
  },
}
</script>
